<template>
  <WdsStack justify-center align-center class="tw-w-full">
    <WdsStack class="tw-w-full" direction-column>
      <Loading v-for="index in count" :key="index" :avatar="avatar" :no-bg="noBg" />
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import Loading from '@/components/Dashboard/Widgets/Utils/Loading.vue'

withDefaults(defineProps<{ count?: number; avatar?: boolean; noBg?: boolean }>(), {
  count: 3,
  avatar: false,
  noBg: false,
})
</script>
